import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'

const useScript = (url) => {
  React.useEffect(() => {
    const script = document.createElement('script')

    script.src = url
    script.async = true

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [url])
}

export const useIsMobile = () => {
  const isMobile = useMediaQuery('(max-width:700px)')
  return isMobile
}

export default useScript
